import { create } from "zustand";

type FormErrors = Record<string, string | undefined>;

// I should add my finance, budget and state values here?
export interface FormValues {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	enquiry: string;
	budget: string;
	state: string;
	requireFinance: string;
}
// I should add my finance, budget and state values here?
export const initialFormValues: FormValues = {
	firstName: "",
	lastName: "",
	email: "",
	phone: "",
	enquiry: "",
	budget: "",
	state: "",
	requireFinance: "Yes",
};

export interface FormData {
	formValues: FormValues;

	// Initializes formValues
	resetFormValues: () => void;

	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
}

export interface FormData {
	formValues: FormValues;
	formErrors: FormErrors;

	// Initializes formValues
	resetFormValues: () => void;

	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
	setFormError: (field: keyof FormValues, message: string) => void;
}

export const useFormData = () =>
	create<FormData>((set) => ({
		formValues: { ...initialFormValues },
		formErrors: {},

		resetFormValues: () =>
			set(() => ({
				formValues: { ...initialFormValues },
			})),

		// Dynamic setter function to update form fields
		setFormValue: (field, value) =>
			set((state) => ({
				formValues: {
					...state.formValues,
					[field]: value,
				},
			})),

		setFormError: (field, message) =>
			set((state) => ({
				formErrors: {
					...state.formErrors,
					[field]: message,
				},
			})),
	}));
